import React, {useState, useRef, useEffect} from 'react';
import {useDispatch, useSelector} from 'react-redux';
import Select from 'react-select';

import {resetSelectedItems, stateContractReset} from '../../redux/actions/contractAction';
import {Radio, Message} from '../utilites';
import OverdlueContentAll from './OverdueContentAll/OverdueContentAll';
import RegisterGoHran from './RegisterGoHran/RegisterGoHran';
import TNStore from './TNStore/TNStore';
import WitndrawalInwentory from './WitndrawalInwentory/WitndrawalInwentory';
import {contractStatuses, facets, groups, listRoles} from '../../helpers/data-constants';
import {getCashbox, getDepartmentsTab, resetAllOptions} from '../../redux/actions/handbookAction';
import {authService} from '../../services/auth-service';
import _isEqual from 'lodash/isEqual';
import {
  calculationAccess,
  getUserFromLocalStorage,
  preventPlusMinusChars,
  splitOptionsByGroup,
  useQuery
} from '../../helpers/common';
import { messages } from '../../helpers/messages';
import './overdue.scss';
import Garage from './Garage/Garage';
import {getDealNumber, getFullNameDeal} from "../../redux/actions/clientsAction";
import CrossSmallIcon from "../../assets/icons/cross-small.svg";
import Loader from "../Users/Loader/Loader";

const initialRadio = [
  {label: 'Просроченные', id: contractStatuses.EXPIRED.param},
  {label: 'Для передачи', id: contractStatuses.TOTRANSFER.param},
  {label: 'ГоХран', id: contractStatuses.GOHRAN.param},
  {label: 'Архив', id: contractStatuses.SALED_GOHRAN.param},
  {label: 'Передано', id: contractStatuses.GOHRAN_SALE.param},
  {label: 'Магазин', id: contractStatuses.STORE.param},
  {label: 'Продано', id: contractStatuses.SALED_STORE.param},
  {label: 'Изъятие', id: contractStatuses.WITHDRAWAL.param},
  {label: 'Инвентарь', id: contractStatuses.INVENTORY.param},
  {label: 'Гараж', id: contractStatuses.GARAGE.param},
  {label: 'Архив-Гараж', id: contractStatuses.GARAGE_ARCHIVE.param},
];

const accessByDepartments = [
  listRoles.ACCOUNTANT,
  listRoles.ADMIN,
  listRoles.DIRECTOR,
  listRoles.MARKETER,
];

const searchStatus = [
  contractStatuses.EXPIRED.param,
  contractStatuses.TOTRANSFER.param,
  contractStatuses.GOHRAN.param,
  contractStatuses.SALED_GOHRAN.param,
  contractStatuses.STORE.param,
  contractStatuses.SALED_STORE.param,
  contractStatuses.WITHDRAWAL.param,
  contractStatuses.INVENTORY.param,
  contractStatuses.GARAGE.param,
  contractStatuses.GARAGE_ARCHIVE.param,
]

const Overdue = ({setTitlePage}) => {
  const {departments, loading, commonError, cashbox, clients, dealsNumber} = useSelector(({handbook}) => handbook);

  const {accessFeatures, isLoadingConfiguration} = useSelector(({user}) => user);
  const dataActiveCashbox = useRef(authService.getActiveCashBoxId());
  const query = useQuery()
  const queryDealStatus = query.get('dealStatus')
  const [state, setState] = useState({
    layout: queryDealStatus ? queryDealStatus : contractStatuses.EXPIRED.param,
    cashBoxIds: [dataActiveCashbox.current],
    fullName: [],
    dealNumber: [],
    typeDeal: [],
    typeDuration: [],
    delaysDay: {
      from: null,
      to: null
    },
  });
  const [error, setError] = useState('')
  let initialFacets = []
  const [entityFacets, setEntityFacets] = useState(initialFacets);
  const [cashBoxInfo, setCashBoxInfo] = useState({
    name: '',
    id: '',
    address: '',
  });
  const sessionCashBoxId = +authService.getActiveCashBoxId().value;
  const dispatch = useDispatch();
  const showAllDepartments = calculationAccess(accessByDepartments);
  const userInfo = getUserFromLocalStorage();
  const goodsSpecialist = (userInfo.roles.length === 1 && userInfo.roles.includes(listRoles.GOODS_SPECIALIST)) ||
    (userInfo.roles.length === 2 && userInfo.roles.includes(listRoles.GOODS_SPECIALIST, listRoles.LOYAL_GOODS_SPECIALIST));
  const departmentRef = useRef(null);
  const fullNameRef = useRef(null);
  const dealNumberRef = useRef(null);
  const typeRef = useRef(null);
  const termFacets = facets.TERM;

  const dealOptions = [
    { label: 'Тип залога', group: groups.DEAL, options: entityFacets },
    { label: 'Тип договора', group: groups.DURATION, options: termFacets }
  ];

  useEffect(() => {
    const initialEntityFacets = getInitialFacets();
    setEntityFacets(initialEntityFacets);
  }, [accessFeatures]);

  useEffect(() => {
    accessFeatures['title.header_section'] && setTitlePage('Просроченные');
  }, [isLoadingConfiguration]);

  useEffect(() => {
    if (accessFeatures["cars.feature"]) {
      setEntityFacets([
        {value: 'car', label: 'Автомобиль', active: false},
        {value: 'thing', label: 'Вещи', active: false},
        {value: 'purity', label: 'Д/м', active: false},
      ])
    } else {
      setEntityFacets([
        {value: 'thing', label: 'Вещи', active: false},
        {value: 'purity', label: 'Д/м', active: false},
      ]);
    }
  }, [accessFeatures])

  useEffect(() => {
    if (
      state.layout === contractStatuses.TOTRANSFER.param ||
      state.layout === contractStatuses.STORE.param ||
      state.layout === contractStatuses.GARAGE.param
    ) {
      dispatch(getCashbox({id: sessionCashBoxId}));
    }
  }, [state.layout, dispatch, sessionCashBoxId]);

  useEffect(() => {
    if (!_isEqual(cashbox, {})) {
      setCashBoxInfo(() => ({
        name: cashbox.name,
        id: cashbox.id,
        address: `${cashbox.city ? `г. ${cashbox.city},` : ''} ул. ${cashbox.street}, д. ${
          cashbox.house
        }, ${cashbox.building ? 'к. ' + cashbox.building + ',' : ''} каб. ${cashbox.office}`,
      }));
    }
  }, [cashbox]);

  useEffect(() => {
    const radioElement = document.getElementById(state.layout);
    if (radioElement) {
      radioElement.checked = true;
    }
  }, [state.layout]);

  const getInitialFacets = () => {
    return accessFeatures["cars.feature"]
        ? facets.ENTITY.CARS_FEATURE
        : facets.ENTITY.DEFAULT;
  };

  const handleLayoutChange = (event) => {
    const target = event.target;
    if (target.id) {
      target.id !== state.layout && dispatch(stateContractReset());
      setState((prev) => ({
        ...prev,
        layout: target.id,
      }));
    }
  };

  const renderLayout = (view) => {
    switch (view) {
      case contractStatuses.EXPIRED.param:
      case contractStatuses.TOTRANSFER.param:
        return (
          <OverdlueContentAll
            dealStatus={view}
            searchState={state}
            cashBoxInfo={cashBoxInfo}
            searchFacets={entityFacets}
            setError={setError}
          />
        );
      case contractStatuses.GOHRAN.param:
      case contractStatuses.SALED_GOHRAN.param:
      case contractStatuses.GOHRAN_SALE.param:
        return <RegisterGoHran dealStatus={view}
                               stateSearch={state}
                               setError={setError}
        />;
      case contractStatuses.STORE.param:
      case contractStatuses.SALED_STORE.param:
        return (
          <TNStore
            dealStatus={view}
            cashBoxInfo={cashBoxInfo}
            stateSearch={state}
            dataActiveCashbox={dataActiveCashbox}
            setError={setError}
          />
        );
      case contractStatuses.WITHDRAWAL.param:
      case contractStatuses.INVENTORY.param:
        return <WitndrawalInwentory dealStatus={view}
                                    stateSearch={state}
                                    setError={setError}
        />;
      case contractStatuses.GARAGE.param:
      case contractStatuses.GARAGE_ARCHIVE.param:
        return (
          <Garage
            dealStatus={view}
            cashBoxInfo={cashBoxInfo}
            stateSearch={state}
            dataActiveCashbox={dataActiveCashbox}
            setError={setError}
          />
        )
      default:
        return null;
    }
  };

  const handleGetAction = (e, action) => {
    const {name} = action
    if (action.action === 'input-change' && name === 'department') {
      const data = {
        name: e,
        restrictionRole: !showAllDepartments,
        status: searchStatus.join(','),
      }
      if (state.dealNumber && state.dealNumber.length > 0) {
        data.dealIds = state.dealNumber.map(i => i.value).join(',')
      }
      if (state.fullName && state.fullName.length > 0) {
        data.clientIds = state.fullName.map(i => i.value).join(',')
      }
      dispatch(getDepartmentsTab(data))
    }
    if (action.action === 'input-change' && name === 'fullName') {
      const data = {
        size: 5,
        page: 1,
        sortBy: 'fullName',
        name: e,
        filters: {
          status: searchStatus.join(','),
        },
      }
      if (state.cashBoxIds && state.cashBoxIds.length > 0) {
        data.filters.cashBoxIds = state.cashBoxIds.map(i => i.value).join(',')
      }
      if (state.dealNumber && state.dealNumber.length > 0) {
        data.filters.dealIds = state.dealNumber.map(i => i.value).join(',')
      }
      dispatch(getFullNameDeal(data));
    }
    if (action.action === 'input-change' && name === 'dealNum') {
      const data = {
        size: 10,
        page: 1,
        filters: {
          status: searchStatus.join(','),
        },
        descending: false,
        sortBy: 'dealNumber',
        number: e
      }
      if (state.cashBoxIds && state.cashBoxIds.length > 0) {
        data.filters.cashBoxIds = state.cashBoxIds.map(i => i.value).join(',')
      }
      if (state.fullName && state.fullName.length > 0) {
        data.filters.clientIds = state.fullName.map(i => i.value).join(',')
      }
      dispatch(getDealNumber(data))
    }
  }

  const chooseFullName = (name) => {
    if (name && Array.isArray(state.fullName)) {
      if (!state.fullName.find(({value}) => value === name.value)) {
        const newArrFullName = [...state.fullName]
        newArrFullName.push(name)

        setState({
          ...state,
          fullName: newArrFullName,
        });
        dispatch(resetSelectedItems())
        dispatch(resetAllOptions())
      }
    }
  }

  const chooseDealsNumber = (number) => {
    if (number && Array.isArray(state.dealNumber)) {
      if (!state.dealNumber.find(({value}) => value === number.value)) {
        const newArrDealsNumber = [...state.dealNumber]
        newArrDealsNumber.push(number);
        const layout = number.dealStatus === contractStatuses.SALED_GOHRAN.param ? contractStatuses.GOHRAN_SALE.param : number.dealStatus

        setState({
          ...state,
          dealNumber: newArrDealsNumber,
          layout: layout
        });
        dispatch(resetSelectedItems())
        dispatch(resetAllOptions())
      }
    }
  }

  const handleTypeDeal = (selectedOptions) => {
    const groupedSelected = splitOptionsByGroup(selectedOptions, dealOptions);

    setState(prevState => ({
      ...prevState,
      typeDeal: groupedSelected.typeDeal || [],
      typeDuration: groupedSelected.typeDuration || [],
    }));
    dispatch(resetSelectedItems());
  };

  const chooseDepartments = (department) => {
    if (department && Array.isArray(state.cashBoxIds)) {
      if (!state.cashBoxIds.find(({value}) => value === department.value)) {
        const newArrDepartments = [...state.cashBoxIds];
        newArrDepartments.push(department);

        setState((prev) => ({
          ...prev,
          cashBoxIds: newArrDepartments,
        }));
        dispatch(resetSelectedItems())
        dispatch(resetAllOptions())
      }
    }
  };

  const handleReset = () => {
    setState((prev) => ({
      ...prev,
      cashBoxIds: [dataActiveCashbox.current],
      fullName: [],
      dealNumber: [],
      typeDeal: [],
      delaysDay: {
        from: null,
        to: null
      }
    }));

    const initialFacets = getInitialFacets();
    setEntityFacets(initialFacets);

    departmentRef.current.select.clearValue();
    fullNameRef.current.select.clearValue();
    dealNumberRef.current.select.clearValue();
    typeRef.current.select.clearValue();

    dispatch(resetSelectedItems())
  };

  const deleteChoice = (value, action) => {
    let filteredArrFullName = [];
    let filteredArrDealsNumber = [];

    if (!goodsSpecialist) {
      if (action === 'department' || (action === undefined && typeof value === 'number')) {
        const filteredArrDepartments = state.cashBoxIds.filter((i) => i.value !== value);

        setState((prev) => ({
          ...prev,
          cashBoxIds: filteredArrDepartments,
        }));
        departmentRef.current.select.clearValue();
      }
    }

    if (action === 'fullName') {
      filteredArrFullName = state.fullName.filter(el => el.value !== value)

      setState((prev) => ({
        ...prev,
        fullName: filteredArrFullName,
      }));
      fullNameRef.current.select.clearValue();
    }
    if (action === 'dealNumber') {
      filteredArrDealsNumber = state.dealNumber.filter(el => el.value !== value)

      setState((prev) => ({
        ...prev,
        dealNumber: filteredArrDealsNumber,
      }));
      dealNumberRef.current.select.clearValue();
    }
    dispatch(resetSelectedItems())

    if (typeof value === 'string')  {
      const filteredArrTypesDeal = {
        typeDeal: state.typeDeal.filter(el => el.value !== value),
        typeDuration: state.typeDuration.filter(el => el.value !== value),
      }

      setState((prev) => ({
        ...prev,
        ...filteredArrTypesDeal
      }));
    }
  };

  const renderFasets = (facets) => {
    return (
      facets?.length !== 0 &&
      facets?.map((i) => {
        return (
          <button
            type="button"
            className="search-facet"
            key={i.value}
            onClick={() => deleteChoice(i.value, i.action)}
            id="button">
            <span htmlFor="button" className={'not-crossed'}>
              {i.label}
            </span>
          </button>
        );
      })
    );
  };

  const renderRadio = () => {
    return initialRadio.map((i) => {
      if (!accessFeatures['cars.feature'] && (i.id === contractStatuses.GARAGE.param || i.id === contractStatuses.GARAGE_ARCHIVE.param)) {
        return null;
      }

      return (
        <Radio
          key={i.id}
          pillboxStyle={true}
          label={i.label}
          id={i.id}
          name="radioNameContractsSwitcher"
          checked={i.id === state.layout}
        />
      );
    });
  };

  const handleInputChange = (e) => {
    const {value, name} = e.target;

    if (value !== '' && !Number.isInteger(parseFloat(value))) {
      return;
    }

      const newValue = value.replace(/^0(?=\d)/, '');

    setState(prevState => {
      let updatedDelaysDay = {
        ...prevState.delaysDay,
        [name]: newValue
      };

      if (name === 'to' && newValue === '') {
        updatedDelaysDay = {
          ...updatedDelaysDay,
          to: null
        };
      }
      if (name === 'from' && newValue === '') {
        updatedDelaysDay = {
          ...updatedDelaysDay,
          from: null
        };
      }
      return {
        ...prevState,
        delaysDay: updatedDelaysDay
      };
    });
  };

  return (
    <main className="app-content">
      { isLoadingConfiguration ?
        (<div className="content-inner">
            <Loader pageRange={1}/>
          </div>) :
        (<>
          {
            !accessFeatures['title.header_section'] &&
            <div className="content-header">
              <h1>Просроченные</h1>
            </div>
          }
          <div className="content-inner">
            <div className="content-inner-data overdue-inner-data">
              <div className="content-datatable-header">
                <div className="d-flex flex-column align-center m-l-auto m-r-auto">
                  <div className="content-datatable-header-center">
                    <div className="action-items">
                      <Select
                        ref={departmentRef}
                        className="basic-multi-select overdue-searchItem"
                        placeholder="Введите подразделение"
                        isLoading={loading}
                        options={departments}
                        noOptionsMessage={() => 'Нет результатов'}
                        loadingMessage={() => 'Загрузка...'}
                        onInputChange={(value, action) =>
                          handleGetAction(value, {...action, name: 'department'})
                        }
                        onChange={chooseDepartments}
                      />
                      <Select
                        ref={fullNameRef}
                        className="basic-multi-select overdue-searchItem"
                        placeholder="Введите ФИО"
                        isLoading={loading}
                        options={clients}
                        noOptionsMessage={() => 'Нет результатов'}
                        loadingMessage={() => 'Загрузка...'}
                        onInputChange={(value, action) =>
                          handleGetAction(value, {...action, name: 'fullName'})
                        }
                        onChange={chooseFullName}
                      />

                      <Select
                        ref={dealNumberRef}
                        className="basic-multi-select overdue-searchItem"
                        placeholder="Введите номер договора"
                        isLoading={loading}
                        options={dealsNumber}
                        noOptionsMessage={() => 'Нет результатов'}
                        loadingMessage={() => 'Загрузка...'}
                        onInputChange={(value, action) =>
                          handleGetAction(value, {...action, name: 'dealNum'})
                        }
                        onChange={chooseDealsNumber}
                      />
                      <Select
                          ref={typeRef}
                          className="overdue-searchItem"
                          placeholder="Тип залога / Тип договора"
                          isLoading={loading}
                          options={dealOptions}
                          closeMenuOnSelect={false}
                          noOptionsMessage={() => 'Нет результатов'}
                          loadingMessage={() => 'Загрузка...'}
                          onChange={handleTypeDeal}
                          hideSelectedOptions={false}
                          controlShouldRenderValue={false}
                          value={[...state.typeDeal, ...state.typeDuration]}
                          isMulti
                      />
                      {accessFeatures['expired.delay_days_filter'] &&
                        <div className='overdue-delayDaysBloc'>
                          <div className='overdue-searchItemDelayDays'>
                            <div>
                              <span>От</span>
                              <input
                                name='from'
                                type='number'
                                                        onChange={e => handleInputChange(e)}
                                                        onKeyDown={preventPlusMinusChars}
                                                        className={error ? 'input-small overdue-errorInput' : 'input-small overdue-delayDayItem'}
                                                        placeholder='Дней'
                                                        value={state.delaysDay.from ? state.delaysDay.from : ''}
                                                        max={10000}
                                                        min={1}
                                                    />
                                                </div>
                                                <div>
                                                    <span>До</span>
                                                    <input
                                                        name='to'
                                                        type='number'
                                onChange={e => handleInputChange(e)}
                                onKeyDown={preventPlusMinusChars}
                                className={error ? 'input-small overdue-errorInput' : 'input-small overdue-delayDayItem'}
                                placeholder='Дней'
                                value={state.delaysDay.to ? state.delaysDay.to : ''}
                                max={10000}
                                min={1}
                              />
                            </div>
                          </div>
                          {error && <div className="overdue-errorDelayDays">{error}</div>}
                        </div>
                      }
                    </div>
                  </div>
                  <div className="content-datatable-header-fullwidth">
                    <div className="pillbox-radiogroup m-l-auto m-r-auto justify-center overdue-select"
                         onClick={handleLayoutChange}>
                      {renderRadio()}
                    </div>
                    <div className="overdue-searchFacets">
                      {
                        state.cashBoxIds.length ?
                          <div className="search-facets-pillboxes overdue-facet">
                            <h4 className='overdue-titleFacets'>Подразделения:</h4>
                            {renderFasets(state.cashBoxIds)}
                          </div> : null
                      }
                      {
                        state.fullName.length ?
                          <div className="search-facets-pillboxes overdue-facet">
                            <h4 className='overdue-titleFacets'>ФИО клиента:</h4>
                            {renderFasets(state.fullName)}
                          </div> : null
                      }
                      {
                        state.dealNumber.length ?
                          <div className="search-facets-pillboxes overdue-facet">
                            <h4 className='overdue-titleFacets'>Номер договора:</h4>
                            {renderFasets(state.dealNumber)}
                          </div> : null
                      }
                      {
                        state.typeDeal.length ?
                          <div className="search-facets-pillboxes overdue-facet">
                            <h4 className='overdue-titleFacets'>Тип залога:</h4>
                            {renderFasets(state.typeDeal)}
                          </div> : null
                      }
                      {
                        state.typeDuration.length ?
                          <div className="search-facets-pillboxes overdue-facet">
                            <h4 className='overdue-titleFacets'>Тип договора:</h4>
                            {renderFasets(state.typeDuration)}
                          </div> : null
                      }
                      <div className="search-facets-actions overdue-resetAll">
                        <button className="button-icontrigger noborder" onClick={handleReset}>
                          <span className="icon"><CrossSmallIcon/></span>
                          <span>Сбросить</span>
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="content-inner-data-container">
                {commonError && commonError !== messages[16007] && <Message type="error" text={commonError}/>}
                {renderLayout(state.layout)}
              </div>
            </div>
          </div>
        </>)
      }

    </main>
  );
};

export default Overdue;
